<div class="pageheader">
    <div class="page-title">
        <h1>Initialize Steps</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Initialize Steps log'">
                <app-change-log-link-entity type="InitStep"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="xcontainer xcontainer-fixed">
    <div class="xrow">
        <div class="col-sm-12">
            <dx-data-grid #itineraryStepsGrid
                          biz-grid
                          [selection]='{ mode: "none" }'
                          [dataSource]='initSteps'
                          [bizHideSelectedRowsComponent]="true"
                          [showResetButton]="true"
                          (onInitNewRow)="onInitNewRow($event)"
                          (onRowInserting)="onRowInserting($event)"
                          (onRowUpdating)="onRowUpdated($event)"
                          (onRowRemoving)="onRowRemoving($event)"
                          (onEditorPreparing)="onEditorPreparing($event)"
                          [bizEditRowOnDoubleClick]="true">

                <dxo-editing mode="popup"
                             [allowAdding]="hasItinStepCreatePerm"
                             [allowUpdating]="allowUpdatingRow"
                             [allowDeleting]="allowDeletingRow">
                    <!--<dxo-form [customizeItem]="customizeItem"></dxo-form>-->
                </dxo-editing>

                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                <dxi-column dataField="Name" caption="Name" dataType="string" [allowGrouping]="false" sortOrder="asc"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
                <dxi-column dataField="Description" caption="Description" dataType="string" [allowGrouping]="false"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
                <dxi-column dataField="ArtifactId" caption="Artifact" dataType="string" editCellTemplate="artifactEditTemplate" [customizeText]="displayExprArtifact"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
                <dxi-column dataField="StepKey" caption="Step Key" dataType="string" [allowGrouping]="false" [allowEditing]="false"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>

                <dxi-column type="buttons">
                    <dxi-button name="edit"></dxi-button>
                    <dxi-button name="delete"></dxi-button>
                    <dxi-button text="Show Log"
                                template="logTemplate"
                                [visible]="allowShowLog">
                    </dxi-button>
                </dxi-column>

                <ng-container *dxTemplate="let cell of 'logTemplate'">
                    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
                        <app-change-log-link-entity type="InitStep" [id]="cell.data.Id"></app-change-log-link-entity>
                    </app-change-log-link>
                </ng-container>

                <ng-container *dxTemplate="let cellInfo of 'artifactEditTemplate'">
                    <app-developer-artifact-assembly-picker [assemblyTypes]="['InitStep']" (selectedArtifactIdChange)="setArtifactId($event, cellInfo)" [selectedArtifactId]="cellInfo.data.ArtifactId"></app-developer-artifact-assembly-picker>
                </ng-container>
            </dx-data-grid>
        </div>
    </div>
</div>
